export default "__VITE_ASSET__0d2a9047__"